<template>
  <b-container>
    <div style="overflow: hidden auto; max-height: 80vh;">
      <b-row v-for="article in articleList" :key="article._id" class="mt-4">
        <b-col cols="4">
          <b-img :src="article.ossUrl" style="width: 100%"></b-img>
        </b-col>
        <b-col cols="7">
          <b-row>
            <b-col>
              <h5>{{article.articleTitle}}</h5>
              <div class="small-text">{{article.showTime}}</div>
              <div>{{`${article.articleContent.slice(0,100)}...`}}</div>
              <div style="display: flex; justify-content: space-between;" class="small-text">
                <div @click="goDetail(article._id)" class="cursor text-primary">查看详情</div>
                <div @click="getDelete(article._id)" class="text-danger cursor">删除</div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <b-row class="mt-4">
      <el-pagination
        :total="count"
        :page-size="10"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </b-row>
  </b-container>
</template>

<script>
import pageMixin from '../mixins/page';
import deleteMixin from '../mixins/delete';

export default {
  name: 'ArticleList',
  mixins: [pageMixin, deleteMixin],
  data() {
    return {
      ListUrl: this.getDomain() + 'article/list',
      articleList: []
    }
  },
  methods: {
    getList() {
      this.__axios(this.ListUrl, this.page, this.handleList)
    },
    handleList(res) {
      this.articleList = res.data.data.list;
      this.articleList.forEach(item => {
        let d = new Date(item.createTime);
        item.showTime = `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
      });
      this.count = res.data.data.count
    },
    goDetail(id) {
      this.$router.push(`/index/detail?_id=${id}`)
    }
  },
  created() {
    this.getList()
  }
}
</script>
